import { render } from "./update-prompt.vue?vue&type=template&id=2aa79f01&scoped=true"
import script from "./update-prompt.vue?vue&type=script&lang=js"
export * from "./update-prompt.vue?vue&type=script&lang=js"

import "./update-prompt.vue?vue&type=style&index=0&id=2aa79f01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa79f01"]])

export default __exports__